module["exports"] = [
  "ie",
  "com",
  "net",
  "info",
  "eu"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/internet/domain_suffix.js
// module id = 557
// module chunks = 0